import { GTMEvent } from '~/lib/gtm/GTM'

export const adaptCreateList = () => {
  return {
    event: GTMEvent.CREATE_LIST,
  }
}
